<template>
<v-layout row class="align-center layout pl-0 pt-0 app--page-header">
    <div class="page-header-left">
        <v-breadcrumbs divider="-" :items="breadcrumbs">
            <template v-slot:item="props">
                <v-breadcrumbs-item :href="props.item.href" :class="[props.item.disabled && 'disabled']">
                    <h3>{{ props.item.text }}</h3>
                </v-breadcrumbs-item>
            </template>
        </v-breadcrumbs>
        <template v-if="breadcrumbs.length == 0">
            <v-breadcrumbs>
                <v-breadcrumbs-item>
                    <h3>{{ routeName }}</h3>
                </v-breadcrumbs-item>
            </v-breadcrumbs>
        </template>
    </div>
    <v-spacer></v-spacer>
    <div class="page-header-right pr-6">
        <v-btn small v-if="$route.meta.saveButton && !options.invisibleSaveButton" @click="saveData" v-shortkey.once="['ctrl', 's']" @shortkey="saveData">
            <v-icon color="#0f7896">save</v-icon>  {{$route.meta.saveButtonText ? $route.meta.saveButtonText : 'SAVE'}}
        </v-btn>
        <v-btn small v-if="$route.meta.createButton && !options.invisibleCreateButton" @click="createData" v-shortkey.once="['alt', 'n']" @shortkey="createData">
            <v-icon color="#0f7896">{{$route.meta.createButtonIcon ? $route.meta.createButtonIcon : 'add'}}</v-icon>  {{$route.meta.createButtonText ? $route.meta.createButtonText : 'ADD'}}
        </v-btn>
        <v-btn small v-if="$route.meta.importButton && !options.invisibleImportButton" @click="importData" v-shortkey.once="['alt', 'i']" @shortkey="importData">
            <v-icon color="#0f7896">file_upload</v-icon> {{$route.meta.importButtonText ? $route.meta.importButtonText : 'IMPORT'}}
        </v-btn>
        <v-btn small v-if="$route.meta.refreshButton" @click="refreshData" v-shortkey.once="['alt','f5']" @shortkey="refreshData">
            <v-icon class="text--secondary">refresh</v-icon>  {{$route.meta.refreshButtonText ? $route.meta.refreshButtonText : 'REFRESH'}}
        </v-btn>
    </div>
</v-layout>
</template>

<script>
import menu from "@/api/menu";
import paths from "@/router/paths";
import {
    buildBreadcrumb
} from "@/commons/utils";
export default {
     data() {
        return {
            options: {}
        }
     },
    computed: {
        routeName() {
            var title = this.$route.params.title ? this.$route.params.title : this.$route.meta.title;
            return title ? title : this.$route.name;
        },
        breadcrumbs: function () {
            let breadcrumbs = [];
            let routeName = this.$route.name;
            breadcrumbs = buildBreadcrumb(routeName, this.$route.path, this.$route.params.Pid, this.$route.params.title, menu, paths);
            return breadcrumbs;
        }
    },
    methods: {
        saveData() {
            window.getApp.$emit('PRE_SAVE_DATA');
        },
        createData() {
          this.$root.$emit('REQUEST_CREATE_DATA');
        },
        importData() {
          this.$root.$emit('REQUEST_IMPORT_DATA');
        },
        refreshData() {
          this.$root.$emit('REQUEST_REFRESH_DATA');
        },
        changeOption(options) {
            this.options = options;
        }
    },
    mounted() {
        this.$root.$on("REQUEST_ROOT_OPTION", this.changeOption);
    }
};
</script>
